<ion-list>
  <ion-item *ngFor="let item of priorityItems">
    <ion-label>{{ item.label }}</ion-label>
    <ion-checkbox [(ngModel)]="item.checked"></ion-checkbox>
  </ion-item>
</ion-list>
